import { type ForwardedRef, forwardRef, type InputHTMLAttributes } from "react";

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
    labelText?: string;
    required?: boolean;
    isInvalid?: boolean;
    errorMessage?: string;
    placeholder?: string;
}

const TextInput = (
    {
        id,
        labelText,
        required,
        isInvalid,
        type,
        errorMessage,
        placeholder,
        ...rest
    }: TextInputProps,
    ref: ForwardedRef<HTMLInputElement>
) => {
    return (
        <div className="form-group mb-4">
            {labelText && (
                <label className="mb-2" htmlFor={id}>
                    {labelText}
                    {required && <span className="text-danger">*</span>}
                </label>
            )}

            <input
                {...rest}
                id={id}
                ref={ref}
                name={id}
                className={`form-control mb-0 ${isInvalid ? "is-invalid" : ""}`}
                type={type ? type.toLowerCase() : "text"}
                placeholder={placeholder ?? (!placeholder && labelText && `Enter ${labelText}`)}
                required={required}
                autoComplete="off"
            />
            {isInvalid && <div className="invalid-feedback">{errorMessage ?? "Invalid Value"}</div>}
        </div>
    );
};

export default forwardRef<HTMLInputElement, TextInputProps>(TextInput);
